module.exports = "/images/ico-classic-red.png?a58b80251ab6d7c0144799f5b2008c92";


//////////////////
// WEBPACK FOOTER
// ./resources/images/project-img/ico-classic-red.png
// module id = Me7J
// module chunks = 1